import { useEffect } from "react";
import { useOperatingAoiContext } from "../stores/useOperatingAoiContext";
import { useImageryStackStore } from "../stores/useImageryStackStore";

export function useSyncOperatingAoiImagery() {
  const activeOperatingAoiId = useOperatingAoiContext(
    s => s.activeOperatingAoiId
  );

  const loadCatalog = useImageryStackStore(s => s.loadCatalog);

  useEffect(() => {
    if (activeOperatingAoiId) {
      loadCatalog({ operatingAoiId: activeOperatingAoiId });
    } else {
      loadCatalog();
    }
  }, [activeOperatingAoiId, loadCatalog]);
}